<script>
import LoginForm from '@/components/forms/Login-form.vue';
import bem from '@/utils/bem';
import { mapState } from 'vuex';

const b = bem('home-page');
export default {
  components: {
    LoginForm,
  },
  mounted() {
    this.redirectToMainPage();
  },
  computed: {
    ...mapState({
      token: (state) => state.auth.idToken,
    }),
  },
  watch: {
    token(newValue, oldValue) {
      if (!oldValue && newValue) {
        this.redirectToMainPage();
      }
    },
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    redirectToMainPage() {
      if (this.token) {
        window.location.href = 'UserAdminPage';
      }
    },
  },
};
</script>

<template>
  <div :class="b()">
    <div :class="b('form-wrap')">
      <LoginForm/>
    </div>
  </div>
</template>

<style src="./style.scss" scoped lang="scss"></style>
